import * as Immutable from "immutable";
import VisualizationConfig from "./VisualizationConfig";
export default class DataTableVisualizationConfig extends VisualizationConfig {
  constructor(pinnedColumns, showRowNumbers) {
    super();
    this._value = { pinnedColumns: pinnedColumns != null ? pinnedColumns : [], showRowNumbers };
  }
  static empty() {
    return this.create([]);
  }
  get pinnedColumns() {
    return Immutable.Set(this._value.pinnedColumns);
  }
  get showRowNumbers() {
    var _a;
    return (_a = this._value.showRowNumbers) != null ? _a : true;
  }
  toBuilder() {
    const { pinnedColumns, showRowNumbers } = this._value;
    return new Builder(Immutable.Map({ pinnedColumns, showRowNumbers }));
  }
  static create(pinnedColumns, showRowNumbers = true) {
    return new DataTableVisualizationConfig(pinnedColumns, showRowNumbers);
  }
  toJSON() {
    const { pinnedColumns, showRowNumbers } = this._value;
    return {
      pinned_columns: pinnedColumns,
      show_row_numbers: showRowNumbers
    };
  }
  static fromJSON(_type, value) {
    const { pinned_columns, show_row_numbers } = value;
    return DataTableVisualizationConfig.create(pinned_columns, show_row_numbers);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  pinnedColumns(value) {
    return new Builder(this.value.set("pinnedColumns", value));
  }
  showRowNumbers(value) {
    return new Builder(this.value.set("showRowNumbers", value));
  }
  build() {
    const { pinnedColumns, showRowNumbers } = this.value.toObject();
    return new DataTableVisualizationConfig(pinnedColumns, showRowNumbers);
  }
}
